import Svg, { Circle, Defs, LinearGradient, Path, Stop } from 'react-native-svg'

type IconProps = {
    size?: number
    color?: string
}

export const PhoneContactIcon = ({ size = 16, color = '#FFFFFF' }: IconProps) => (
    <Svg width={size} height={size} viewBox="0 0 24 24" accessibilityElementsHidden>
        <Path
            fill={color}
            d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.4 21 3 13.6 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.58a1 1 0 0 1-.25 1.02l-2.2 2.19Z"
        />
    </Svg>
)

export const InstagramContactIcon = ({ size = 16 }: IconProps) => (
    <Svg width={size} height={size} viewBox="0 0 24 24" accessibilityElementsHidden>
        <Defs>
            <LinearGradient id="clubContactIgGrad" x1="0%" y1="100%" x2="100%" y2="0%">
                <Stop offset="0%" stopColor="#F58529" />
                <Stop offset="45%" stopColor="#DD2A7B" />
                <Stop offset="75%" stopColor="#8134AF" />
                <Stop offset="100%" stopColor="#515BD4" />
            </LinearGradient>
        </Defs>
        <Path
            fill="url(#clubContactIgGrad)"
            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
        />
    </Svg>
)

export const TelegramContactIcon = ({ size = 16, color = '#2AABEE' }: IconProps) => (
    <Svg width={size} height={size} viewBox="0 0 24 24" accessibilityElementsHidden>
        <Circle cx="12" cy="12" r="12" fill={color} />
        <Path
            fill="#FFFFFF"
            d="M5.5 11.7 16.8 7.3c.5-.2 1 .1.8.9l-1.9 9.1c-.1.6-.5.7-1 .5l-2.8-2.1-1.3 1.3c-.2.1-.3.2-.5.2l.2-2.9 5.2-4.7c.2-.2 0-.3-.3-.1l-6.5 4.1-2.8-.9c-.6-.2-.6-.6.1-.9z"
        />
    </Svg>
)
